import { Layout, Menu } from 'antd';
import styled from 'styled-components';

const AntContent = Layout.Content;

export const Wrapper = styled.div<{ height: string; isMobile?: boolean }>`
  min-height: ${p => p.height};
  background: #ffffff;

  display: flex;

  .ant-layout-content {
    ${p => p.isMobile && `margin: 0px;`}
  }
`;

export const HeadWrapper = styled.div`
  padding: 0px ${p => p.theme.app.padding.vertical};
`;

export const WrapperLogo = styled.div<{ isToggle: boolean }>`
  display: flex;
  align-items: center;
  ${p => !p.isToggle && 'justify-content: center;'}
  height: 98px;
  cursor: pointer;

  .logoText {
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const Logo = styled.img`
  width: 68px;
  height: 50px;
`;

export const LogoFullText = styled.img`
  height: 50px;
`;

export const WrapperMenu = styled.div<{
  isToggle: boolean;
}>`
  width: ${p => (p.isToggle ? '230px' : '94px')};
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #f9f8f8;

  flex-shrink: 0;
  background: #fff;
  position: sticky;
  top: 0;
  left: 0;
  transition: width 0.3s;
  // box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  .ant-layout-sider-trigger {
    background: ${p => p.theme.colors.primary.main};
  }
  z-index: 1000;
`;

export const ContentMenu = styled.div`
  width: 100%;
  height: calc(var(--window-height) - 169px);
  max-height: calc(var(--window-height) - 169px);
  padding: 0px 2px 0px 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const MenuTitle = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: ${p => p.theme.app.padding.vertical};

  .titleText {
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const CMenu = styled(Menu)`
  border-right: none;
`;

export const WrapperContent = styled(AntContent)<{
  isChatPage: boolean;
  margin: string;
}>`
  ${p => p.isChatPage && `height: calc(100vh - 100px)`};
  margin: ${p => p.margin};
  border-radius: 6px !important;
`;

export const WrapperFilter = styled.div<{
  display: string;
}>`
  width: 100%;
  height: auto;
  display: ${p => p.display};
  flex-direction: column;
  white-space: nowrap;

  * {
    // overflow: hidden;
    white-space: nowrap;
  }
`;

export const Content = styled.div<{ width: string }>`
  width: ${p => p.width};
  height: 100%;
`;

export const WrapperTag = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  padding-left: ${p => p.theme.app.padding.vertical};
`;

export const WrapperAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #f05540;
  color: #ffffff;
  font-size: 18px;
`;
